import React from "react";
import cn from "classnames";
import SupportingText from "../SupportingText";

export default function Checkbox({
  disabled,
  checked,
  label,
  labelLeft = false,
  textColor,
  textSize,
  bgColor = "red-light",
  size = 4,
  onChange,
  ...other
}) {
  const defaultStyle = {
    minWidth: "1rem",
    minHeight: "1rem",
    display: "inline-block",
    outline: "none",
    verticalAlign: "middle",
    backgroundImage: `url("data:image/svg+xml;utf8,<svg viewBox='0 0 10 9' xmlns='http://www.w3.org/2000/svg'><path d='M1 4.88l2.378 2.435L9.046 1.6' stroke-width='1.6' stroke='%23FFF' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/></svg>")`,
    backgroundSize: "80%",
    backgroundPosition: "center",
    borderRadius: "50%"
  };

  const inputClass = cn(
    "border",
    `h-${size}`,
    `w-${size}`,
    `bg-no-repeat`,
    labelLeft ? `ml-3` : `mr-3`,
    checked
      ? disabled
        ? `bg-grey border-grey`
        : `bg-${bgColor} border-${bgColor}`
      : "border-grey-light shadow-blur-sm bg-white"
  );

  const BoxElem = () => <span style={defaultStyle} className={inputClass} />;
  const LabelElem = () => (
    <SupportingText
      textColor={`${disabled ? "grey" : textColor}`}
      textSize={textSize}
    >
      {label}
    </SupportingText>
  );

  return (
    <label className="flex items-center">
      <input
        style={{
          display: "none"
        }}
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        {...other}
      />
      {labelLeft
        ? [<LabelElem key={1} />, <BoxElem key={2} />]
        : [<BoxElem key={1} />, <LabelElem key={2} />]}
    </label>
  );
}



// WEBPACK FOOTER //
// ./src/Checkbox/Checkbox.js